export function enableSmilies(selector) {
    $(document).ready(function (e) {
        $(selector).emojiPicker({
            height: '290px',
            width: '290px'
        });
    });
}